import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RolesPermissionsService } from '../../roles-permissions.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NotificationService } from 'src/@core/services/notification.service';
import { AppService } from 'src/@core/services/app.service';
@Component({
  selector: 'hour4u-admin-add-edit-roles',
  templateUrl: './add-edit-roles.component.html',
  styleUrls: ['./add-edit-roles.component.scss']
})
export class AddEditRolesComponent implements OnInit {
  rolesForm: FormGroup;
  permissionsList: any[] = [];
  isLoading: boolean = false;
  diameter = 20;
  loaderColor: string;
  mode = 'indeterminate';
  isViewMode: boolean = false;
  profile = this.appService.getCurrentAccount();

  constructor(
    private _formBuilder: FormBuilder,
    public rolesPermissionsService: RolesPermissionsService,
    public dialogRef: MatDialogRef<AddEditRolesComponent>,
    @Inject(MAT_DIALOG_DATA) public selectedRole: any,
    private notify: NotificationService,
    private appService: AppService
  ) { }

  ngOnInit() {
    this.rolesForm = this._formBuilder.group({
      id: [''],
      roleName: ['', Validators.required],
      roleDescription: ['', Validators.required],
    })
    this.fetchPermissions();
    if (this.selectedRole.actionTitle.includes('View')) {
      this.isViewMode = true;
    }
  }

  fetchPermissions() {
    let entityType = this.profile.entity.entityType;
    this.rolesPermissionsService.fetchPermissions(entityType).subscribe(res => {
      this.permissionsList = res;
      this.permissionsList.forEach(ele => {
        ele.name = ele.permissionName;
        ele.create = false;
        ele.edit = false;
        ele.view = false;
        ele.delete = false;
        ele.isDisabledCreate = false;
        ele.isDisabledView = false;
        ele.hideCreate = false;
        ele.hideView = false;

        ele.hide = false;

        if (ele.name == "DASHBOARD") {
          ele.view = true;
          ele.isDisabledView = true;
        }

        if (ele.name == "MEMBERS_AND_ROLES" || ele.name == "TEAM_MEMBERS") {
          ele.isDisabledCreate = true;
          ele.isDisabledView = true;
        }

        if (entityType == "ENTERPRISE") {
          if (ele.name == "WORKORDER") {
            ele.hideCreate = true;
          }
        }

        // if (ele.name == "QUOTATION" || ele.name == "PURCHASE_ORDER" ||
        //   ele.name == "BILLING" || ele.name == "SUBSCRIPTIONS" || ele.name == "USERS"
        //   || ele.name == "MEMBERS_AND_ROLES") {
        //   ele.isDisabledView = true;
        //   ele.isDisabledCreate = true;
        // }
        if (ele.name == "USERS"
          || ele.name == "PURCHASE_ORDER"
          || ele.name == "QUOTATION"
          || ele.name == "BILLING"
          || ele.name == "MEMBERS_AND_ROLES"
          || ele.name == "VENUES"
          || ele.name == "BOOKINGS"
          || ele.name == "SUBSCRIPTIONS"
          || ele.name == "TEAM_MEMBERS"
          || ele.name == "DIGITAL_PORTFOLIO") {
          ele.hide = true;
        }
        if (ele.name == "APPROVE_CANDIDATES_IN_SHIFTS") {
          ele.view = true;
          ele.hideView = true;
        }
      })
      if (this.selectedRole && this.selectedRole.roleId) {
        this.setValues();
      }
    }, (err => {

    }))
  }

  setValues() {
    this.rolesForm.controls['id'].setValue(this.selectedRole.roleId);
    this.rolesForm.controls['roleName'].setValue(this.selectedRole.roleName);
    this.rolesForm.controls['roleDescription'].setValue(this.selectedRole.description);
    this.rolesForm.controls['id'].updateValueAndValidity();
    this.rolesForm.controls['roleName'].updateValueAndValidity();
    this.rolesForm.controls['roleDescription'].updateValueAndValidity();

    this.permissionsList.forEach(permission => {
      if (this.selectedRole && this.selectedRole.permissions && this.selectedRole.permissions.length) {
        this.selectedRole.permissions.forEach(action => {
          // const [permName, permAction] = action.split('_');

          const lastUnderscoreIndex = action.lastIndexOf('_');

          let permName, permAction;

          if (lastUnderscoreIndex !== -1) {
            permName = action.slice(0, lastUnderscoreIndex);
            permAction = action.slice(lastUnderscoreIndex + 1);
          } else {
            // Handle the case where there is no underscore in the string
            permName = action;
            permAction = '';
          }

          if (permission.permissionName === permName) {
            if (permAction === 'VIEW') {
              permission.view = true;
            } else if (permAction === 'CREATE') {
              permission.create = true;
              permission.delete = true;
              permission.edit = true;
              permission.view = true;
            } else if (permAction === 'EDIT') {
              permission.create = true;
              permission.delete = true;
              permission.edit = true;
              permission.view = true;
            } else if (permAction === 'DELETE') {
              permission.create = true;
              permission.delete = true;
              permission.edit = true;
              permission.view = true;
            }
          }
        });
      }
    });
  }

  writeWithAI() {

  }

  onSlideToggleChange(event, permission, action: any) {
    const updatePermissions = (permission, actions, value) => {
      this.permissionsList.forEach(ele => {
        if (permission.name === "All" || permission.name === ele.name) {
          actions.forEach(act => {
            // Only modify actions that are not disabled
            if ((act === 'view' && !ele.isDisabledView) || (act !== 'view' && !ele.isDisabledCreate)) {
              ele[act] = value;
            }

            // If 'CREATE' is true, set all relevant permissions to true
            if (act === 'create' && value === true && !ele.isDisabledCreate) {
              ele.view = true;
              ele.edit = true;
              ele.delete = true;
            }

            // If 'VIEW' is false, set all relevant permissions to false
            if (act === 'view' && value === false && !ele.isDisabledView && !ele.isDisabledCreate) {
              ele.edit = false;
              ele.create = false;
              ele.delete = false;
            }
          });
        }
      });
    };

    // Determine the actions to update based on the current action
    const actionsToUpdate = action === 'CREATE' ? ['create', 'edit', 'delete', 'view'] : ['view'];

    // Update permissions based on the action
    updatePermissions(permission, actionsToUpdate, permission[action.toLowerCase()]);


  }


  preventToggle(event: Event) {
    event.stopPropagation();
  }

  saveRolesAndPermissions() {
    this.isLoading = true;
    this.permissionsList.forEach(ele => {
      if (ele.name === "USERS") {
        // Check if any of the elements with name "TEAM_MEMBERS", "VENDORS", "CHAMPS", or "ENTERPRISES" have true permissions
        const relatedPermissions = this.permissionsList.filter(p =>
          ["VENDORS", "CHAMPS", "ENTERPRISES", "AGENCIES"].includes(p.name)
        );
        ele.view = false;
        ele.create = false;
        ele.edit = false;
        ele.delete = false;

        // Update "USERS" permissions if any of the related permissions are true
        relatedPermissions.forEach(p => {
          if (p.view) {
            ele.view = true;
          }
          if (p.create) {
            ele.create = true;
          }
          if (p.edit) {
            ele.edit = true;
          }
          if (p.delete) {
            ele.delete = true;
          }
        });
      }
    });

    if (this.rolesForm.valid) {
      let obj = {
        roleName: this.rolesForm.value.roleName,
        entityType: this.profile.entity.entityType,
        roleDescription: this.rolesForm.value.roleDescription,
        permissions: this.permissionsList
      }
      this.rolesPermissionsService.createRoleWithPermissions(obj, this.rolesForm.controls['id'].value).subscribe(res => {
        this.isLoading = false;
        if (res) {
          if (this.rolesForm.controls['id'].value) {
            this.notify.showMessage('Role updated successfully!', 2000);
          } else {
            this.notify.showMessage('Role created successfully!', 2000);
          }
          this.dialogRef.close(res);
        }
      }, (err => {
        this.isLoading = false;
      }))
    } else {
      this.rolesForm.markAllAsTouched();
      this.isLoading = false;
      return;
    }
  }
}
